import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PasswordRequirementDTO} from '../../services/api/api';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {PasswordRequirementsInterface} from '../../services/global/global-interfaces';

@Component({
  selector: 'sb-comp-password-requirement',
  templateUrl: './sb-password-requirement.component.html',
  styleUrls: ['./sb-password-requirement.component.scss'],
  standalone: false,
})
export class SbPasswordRequirementComponent implements OnInit {
  @Input() set pwRequirements(req: PasswordRequirementDTO) {
    if (req) {
      this.pwReq.min = req.minLength;
      this.pwReq.max = req.maxLength;
      this.pwReq.upper = req.minUpperCase;
      this.pwReq.lower = req.minLowerCase;
      this.pwReq.special = req.minSpecialCharacter;
      this.pwReq.space = req.minSpace;
      this.pwReq.num = req.minNumber;
    }
  }

  @Output() requirementsEmitter: EventEmitter<PasswordRequirementsInterface>;

  pwReq: PasswordRequirementsInterface;
  form: UntypedFormGroup;

  constructor() {
    this.pwReq = { min: 0, max: 0, num: 0, space: 0, special: 0, lower: 0, upper: 0 };
    this.requirementsEmitter = new EventEmitter<PasswordRequirementsInterface>();
    this.form = new UntypedFormGroup({
      min: new UntypedFormControl('', [Validators.required]),
      max: new UntypedFormControl('', [Validators.required]),
      upper: new UntypedFormControl('', [Validators.required]),
      lower: new UntypedFormControl('', [Validators.required]),
      special: new UntypedFormControl('', [Validators.required]),
      space: new UntypedFormControl('', [Validators.required]),
      num: new UntypedFormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.registerFormChangesListener();
  }

  get min() {
    return this.form.get('min');
  }

  get max() {
    return this.form.get('max');
  }

  get upper() {
    return this.form.get('upper');
  }

  get lower() {
    return this.form.get('lower');
  }

  get special() {
    return this.form.get('special');
  }

  get num() {
    return this.form.get('num');
  }

  get space() {
    return this.form.get('space');
  }

  private registerFormChangesListener() {
    this.min.valueChanges.subscribe(value => {
      this.pwReq.min = value;
      this.requirementsEmitter.emit(this.pwReq);
    });
    // TODO fill rest
  }
}
